import { RouteObject } from "../../../interfaces/navigation";
import EntryPoint from "../../../containers/Profile/MyPublications/MyPublicationsContainer";
import Detail from "../../../containers/Profile/MyPublications/Detail/EntryPointContainer";
import Edit from "../../../containers/Profile/MyPublications/Edit/EntryPointContainer";
import Management from "../../../containers/Profile/MyPublications/Management/ManagementContainer";

export const myPublicationsSubRoutes: RouteObject[] = [
    {
        title: "Detail",
        path: ":id/detalle",
        component: <Detail/>
    },
    {
        title: "Edit",
        path: ":id/editar",
        component: <Edit/>
    },
    {
        title: "Gestión",
        path: ":id/gestion",
        component: <Management/>
    }
];

export const myPublicationsRoutes: RouteObject[] = [
    {
        title: "Mis Publicaciones",
        path: "mis_publicaciones",
        component: <EntryPoint/>,
        subRoutes: myPublicationsSubRoutes
    }
];